import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { Subheading } from '../../common/components';

const S = {
  Heading: styled(Typography).attrs(() => ({
    as: 'h3',
  }))`
    height: 32px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  `,
  Placeholder: styled.div`
    width: 300px;
    height: 32px;
    background-color: ${({ theme }) => theme.palette.grey[100]};
  `,
};

const Title = ({ children }) => (children !== null
  ? <Subheading>{children}</Subheading> : <S.Placeholder />);

Title.propTypes = {
  children: PropTypes.string,
};

Title.defaultProps = {
  children: null,
};

export default Title;
